/* eslint react/jsx-filename-extension: 0 */
import React from 'react';
import { generatePath } from 'react-router-dom';
import RouterLink from '@/components/common/RouterLink';
import AuthRoutes from '@/constants/routing/AuthRoutes';

export default function getDonationCampaign({
  campaignDisplayName,
  campaignId,
}: {
  campaignDisplayName: string;
  campaignId: string;
}) {
  return {
    hasCampaign: !!campaignId,
    campaignLink: campaignId && (
      <RouterLink to={generatePath(AuthRoutes.CAMPAIGN, { campaignId })}>
        {campaignDisplayName}
      </RouterLink>
    ),
  };
}
